import { Link } from "@reach/router";
import React from "react";
import tbmLogoBlanco from "../../assets/rebrand/logotipo-primary.png";
import simboloBlanco from "../../assets/rebrand/simbolo-primary.png";

const CheckoutHeader = () => {
  return (
    <div className="row border-bottom align-items-center bg-light pb-3 pt-3 mx-0">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-8 col-md-10">
            <h1 className="mb-0">Checkout</h1>
          </div>
          <div className="col-4 col-md-2 text-end">
            <Link to="/">
              <img
                style={{ height: "50px", maxWidth: "unset", objectFit: "contain" }}
                src={simboloBlanco}
                alt="The Body Method"
              />
              <img
                style={{ width: "200px", maxWidth: "unset", objectFit: "contain" }}
                src={tbmLogoBlanco}
                alt="The Body Method"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutHeader;
